import { useQuery } from "@tanstack/react-query";

import { authApi } from "@/api/services";

export const INVITE_DETAILS_QUERY_KEY = "inviteDetails";

export const useGetInviteDetails = (token: string | null) => {
  return useQuery({
    queryKey: [INVITE_DETAILS_QUERY_KEY, token],
    queryFn: () => (token ? authApi.getInviteDetails(token) : Promise.reject()),
    enabled: !!token,
    retry: false,
  });
};
